import { StyledLogo } from './Logo.styled';

const Logo = () => {
  return <StyledLogo />;
};

export default Logo;
